import { useEffect, useRef } from 'react';
import { mountScrollWorld } from '@/lib/scroll-engine';
import { buildConfig, USE_CLIPS } from '@/lib/config';
import { augment, gateDemoGhost, watchScenes } from '@/lib/augment';
import { track } from '@/lib/analytics';

// Wraps the vanilla scroll-world engine, which builds its own DOM + registers global
// scroll/resize listeners and has no teardown. We therefore mount it exactly once
// (the ref guard makes React 18 StrictMode's double-invoke a no-op) and never unmount —
// this is a single-page landing that lives for the life of the document.
export default function ScrollWorld() {
  const hostRef = useRef<HTMLDivElement>(null);
  const mountedRef = useRef(false);

  useEffect(() => {
    if (mountedRef.current || !hostRef.current) return;
    mountedRef.current = true;

    const container = hostRef.current;
    mountScrollWorld(container, buildConfig());
    augment(container);
    watchScenes(container);
    gateDemoGhost();
    track('sw_view', { clips: USE_CLIPS });
  }, []);

  return <div id="world" ref={hostRef} />;
}
